import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import InvestmentPage from "../screens/Investment/Investment/InvestmentPage";
import InvestmentDetails from "../screens/Investment/InvestmentDetails/InvestmentDetails";
import InvestmentBankDetails from "../screens/Investment/BankDetails/InvestmentBankDetails";
import PropertyDetails from "../screens/Investment/Properties/PropertyDetails";
import CurrentQEMIDetails from "../screens/Investment/CurrentQEMI/CurrentQemiDetails";

const Stack = createStackNavigator();

const InvestmentStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Investment" component={InvestmentPage} />
      <Stack.Screen name="InvestmentDetails" component={InvestmentDetails} />
      <Stack.Screen name="BankDetails" component={InvestmentBankDetails} />
      <Stack.Screen name="PropertyDetails" component={PropertyDetails} />
      <Stack.Screen
        name="CurrentQEMIDetails"
        component={CurrentQEMIDetails}
        initialParams={{ source: "Investment" }}
      />
    </Stack.Navigator>
  );
};

export default InvestmentStackNavigator;
